import styles from './Section.module.css';

type BgVariant = 'page' | 'subtle' | 'raised' | 'inverse' | 'brand' | 'brand-dark' | 'dark';

const bgClass: Record<BgVariant, string> = {
  page: styles.page,
  subtle: styles.subtle,
  raised: styles.raised,
  inverse: styles.inverse,
  brand: styles.brand,
  'brand-dark': styles.brandDark,
  dark: styles.dark,
};

interface SectionProps {
  children: React.ReactNode;
  bg?: BgVariant;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  as?: React.ElementType;
  id?: string;
  className?: string;
}

export function Section({
  children,
  bg = 'page',
  size = 'md',
  as: Tag = 'section',
  id,
  className = '',
}: SectionProps) {
  return (
    <Tag
      id={id}
      className={[
        styles.section,
        size !== 'md' ? styles[size] : '',
        bgClass[bg],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </Tag>
  );
}
